import apiCall from "components/Api/api";
import SharedsafariCard from "components/SharedSafari/SharedsafariCard";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SharedsafariCardSkeleton from "./Skeleton/safari/SharedsafariCardSkeleton";
import { useProfileContext } from "provider/ProfileProvider";

const ProfileSharedSafariTab = () => {
  const { user_handle } = useParams();
  const [loading, setLoading] = useState();
  const { userSharedSafariOrg, userSharedSafariJoind, profileDispatch } =
    useProfileContext();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [organizedRes, joinedRes] = await Promise.all([
          apiCall({
            url: `organizedby?user_handle=${user_handle}`,
            method: "GET",
          }),
          apiCall({
            url: `joinedby?user_handle=${user_handle}`,
            method: "GET",
          }),
        ]);

        // Handle errors in either response
        if (organizedRes?.status === 200 && !organizedRes?.data?.errors) {
          const shareSafariData = organizedRes?.data?.share_safari || [];
          // setOrganizedSafariData(shareSafariData);
          profileDispatch({
            type: "SET_USER_SF_ORG_DATA",
            payload: shareSafariData,
          });
        } else {
          console.error("Organized safari error:", organizedRes?.data?.errors);
        }

        if (joinedRes?.status === 200 && !joinedRes?.data?.errors) {
          const joinedData = joinedRes?.data?.share_safari;
          // Do something with userData, maybe setUserDetails(userData)
          // setJoinedSafariData(joinedData);
          profileDispatch({
            type: "SET_USER_SF_JOIN_DATA",
            payload: joinedData,
          });
        } else {
          console.error("User details error:", joinedRes?.data?.errors);
        }
      } catch (err) {
        console.error("Error in parallel fetch:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user_handle]);

  const processedOrganizeData = useMemo(() => {
    return userSharedSafariOrg?.map((sharedSafari) => ({
      ...sharedSafari,
    }));
  }, [userSharedSafariOrg]);

  const processedJoinedData = useMemo(() => {
    return userSharedSafariJoind?.map((sharedSafari) => ({
      ...sharedSafari,
    }));
  }, [userSharedSafariJoind]);

  return (
    <>
      {/* Organized Safari Card */}
      <div className="card card_bodyPadding mb-4">
        <div className="card-body">
          <Row className="gx-xxl-5">
            <div className="d-flex justify-content-between mb-4">
              <h6
                className="fs-6 fw-bold mb-0"
                style={{ paddingBottom: "0px" }}
              >
                {processedOrganizeData?.length} Shared Safari Organized by me
              </h6>
            </div>
            {Array.isArray(processedOrganizeData) &&
            processedOrganizeData.length > 0 ? (
              <>
                {processedOrganizeData.map((safari, index) => (
                  <Col
                    md={6}
                    sm={6}
                    lg={4}
                    className="mb-4"
                    key={safari.id || index}
                  >
                    <SharedsafariCard
                      safari={safari}
                      page={"userProfileOrganized"}
                    />
                  </Col>
                ))}
              </>
            ) : loading ? (
              <SharedsafariCardSkeleton count={3} />
            ) : (
              <p>No safaris available</p>
            )}
          </Row>
        </div>
      </div>

      {/* Joined Safari Card */}
      <div className="card card_bodyPadding">
        <div className="card-body">
          <Row className="gx-xxl-5">
            <div className="d-flex justify-content-between mb-4">
              <h6
                className="fs-6 fw-bold mb-0"
                style={{ paddingBottom: "0px" }}
              >
                {processedJoinedData?.length} Shared Safari Joined by me
              </h6>
            </div>
            {Array.isArray(processedJoinedData) &&
            processedJoinedData.length > 0 ? (
              <>
                {processedJoinedData.map((safari, index) => (
                  <Col
                    md={6}
                    sm={6}
                    lg={4}
                    className="mb-4"
                    key={safari.id || index}
                  >
                    <SharedsafariCard
                      safari={safari}
                      page={"userProfileJoined"}
                    />
                  </Col>
                ))}
              </>
            ) : loading ? (
              <SharedsafariCardSkeleton count={3} />
            ) : (
              <p>No safaris available</p>
            )}
          </Row>

          <nav
            id="w0"
            className="pagination pagination-primary mg-sm-b-0"
          ></nav>
        </div>
      </div>
    </>
  );
};

export default ProfileSharedSafariTab;
